import React from 'react';

export default function GoatTailSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="26.44,28.73 13.86,28.73 14.58,23.28 27.17,23.28" fill="#C4ABC4" />
      <polygon points="13.86,28.73 26.44,28.73 24.7,25.45 12.11,25.45" fill="#996F99" opacity="0.95" />
      <polygon points="13.86,28.73 12.11,25.45 12.83,20.0 14.58,23.28" fill="#996F99" opacity="0.95" />
      <polygon points="26.44,28.73 13.86,28.73 14.58,23.28 27.17,23.28" fill="#C4ABC4" />
      <polygon points="13.86,28.73 26.44,28.73 24.7,25.45 12.11,25.45" fill="#996F99" opacity="0.95" />
      <polygon points="13.86,28.73 12.11,25.45 12.83,20.0 14.58,23.28" fill="#996F99" opacity="0.95" />
      <polygon points="31.99,38.0 3.67,38.0 8.01,5.28 36.33,5.28" fill="#C4ABC4" />
      <polygon points="31.18,24.92 12.3,24.92 14.47,8.56 33.35,8.56" fill="#C4ABC4" />
      <polygon points="12.3,24.92 31.18,24.92 27.7,18.36 8.82,18.36" fill="#996F99" opacity="0.95" />
      <polygon points="12.3,24.92 8.82,18.36 10.98,2.0 14.47,8.56" fill="#996F99" opacity="0.95" />
      <polygon points="30.21,21.15 17.62,21.15 17.62,8.56 30.21,8.56" fill="#C4ABC4" />
      <polygon points="17.62,21.15 30.21,21.15 26.43,19.26 13.84,19.26" fill="#996F99" opacity="0.95" />
      <polygon points="17.62,21.15 13.84,19.26 13.84,6.67 17.62,8.56" fill="#996F99" opacity="0.95" />
    </svg>
  );
}
